import React, { FC } from "react";
import { Updater } from "use-immer";

import { IgAnalyticsTooltip, IgToggleButtonGroup } from "@intelligems/ig-theme";
import { Grid, ToggleButton } from "@mui/material";

interface IntervalOption {
  value: string;
  label: string;
  borderRadius?: {
    left?: boolean;
    right?: boolean;
  };
}

const defaultButtons: IntervalOption[] = [
  {
    value: "HOUR",
    label: "Hourly",
    borderRadius: { left: true },
  },
  {
    value: "DAY",
    label: "Daily",
  },
  {
    value: "WEEK",
    label: "Weekly",
    borderRadius: { right: true },
  },
];

interface GraphIntervalButtonsProps {
  graphInterval: string;
  hasNoData: boolean;
  isLoading: boolean;
  setGraphInterval: Updater<string>;
  intervals?: IntervalOption[];
}
export const GraphIntervalButtons = ({
  hasNoData,
  setGraphInterval,
  graphInterval,
  isLoading,
  intervals = defaultButtons,
}: GraphIntervalButtonsProps) => {
  const buttons = intervals.map((interval) => (
    <ToggleButton
      value={interval.value}
      key={interval.value}
      size={"small"}
      sx={{
        borderRadius: "30px",
        // borderBottomLeftRadius: interval.borderRadius?.left ? 9999 : 0,
        // borderTopLeftRadius: interval.borderRadius?.left ? 9999 : 0,
        // borderBottomRightRadius: interval.borderRadius?.right ? 9999 : 0,
        // borderTopRightRadius: interval.borderRadius?.right ? 9999 : 0,
        // paddingLeft: interval.borderRadius?.left ? "12px" : "8px",
        paddingRight: interval.borderRadius?.right ? "12px" : "8px",
      }}
    >
      {interval.label}
    </ToggleButton>
  ));

  return (
    <IgAnalyticsTooltip
      title={
        hasNoData
          ? "Interval buttons are disabled when no data is returned"
          : isLoading
            ? "Interval buttons are disabled while data is loading"
            : ""
      }
    >
      <IgToggleButtonGroup
        disabled={isLoading || hasNoData}
        buttons={buttons}
        value={graphInterval}
        control={{
          exclusive: true,
          onChange: (event, value: string) => {
            if (value) {
              setGraphInterval(value);
            }
          },
        }}
      />
    </IgAnalyticsTooltip>
  );
};
